import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../Services/apiService";
import { error } from "jquery";



export const AdministrativeCosts = createAsyncThunk("AdministrativeCosts/AddAdministrativeCostsAndMonth",
    async (parameters, { rejectWithValue }) => {
        try {
            //console.log(parameters, "lksldkkdkksssssssssd");
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/AdministrativeCosts/AddAdministrativeCostsAndMonth", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)



export const GetBI_AB_ItemTypeAdministrativeCostsBudget = createAsyncThunk("AdministrativeCosts/GetBI_AB_ItemTypeAdministrativeCostsBudget",
    async (parameters, { rejectWithValue }) => {
        try {
            //console.log(parameters, "lksldkkdkksssssssssd");
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/DropDowns/GetBI_AB_ItemTypeAdministrativeCostsBudget", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)

export const GetAdministrativeCostsAndMonthById = createAsyncThunk("AdministrativeCosts/GetAdministrativeCostsAndMonthById",
    async (parameters, { rejectWithValue }) => {
        try {

            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/AdministrativeCosts/GetAdministrativeCostsAndMonthById", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)


export const EditAdministrativeCostsAndMonth = createAsyncThunk("AdministrativeCosts/EditAdministrativeCostsAndMonth",
    async (parameters, { rejectWithValue }) => {
        try {

            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/AdministrativeCosts/EditAdministrativeCostsAndMonth", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }


)


export const DeleteAdministrativeCostsAndMonth = createAsyncThunk("AdministrativeCosts/DeleteAdministrativeCostsAndMonth",
    async (parameters, { rejectWithValue }) => {
        try {

            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/AdministrativeCosts/DeleteAdministrativeCostsAndMonth", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }


)




export const ValidationAdministrativeCosts = createAsyncThunk("AdministrativeCosts/ValidationAdministrativeCosts",
    async (parameters, { rejectWithValue }) => {
        try {

            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/AdministrativeCosts/ValidationAdministrativeCosts", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field
            if (response.data.success === true) {
                const arrayValidate = response.data.result.map((ele, ind) => {
                    return ele.code;
                });

                return arrayValidate; // Return the extracted data
            }
            return data; // Return the extracted data

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }


)

const AdministrativeCostsReducer = createSlice({
    name: "DirectCosts",
    initialState: {
        AddAdministrativeCosts: {},
        lodingAddAdministrativeCosts: false,
        errorAddAdministrativeCosts: null,


        ItemTypeAdministrativeCostsBudget: [],
        lodingItemTypeAdministrativeCostsBudget: false,
        errorItemTypeAdministrativeCostsBudget: null,

        AdministrativeCostsBudgetAndMonth: {},
        lodingAdministrativeCostsBudgetAndMonth: false,
        errorAdministrativeCostsBudgetAndMonth: null,

        editAdministrativeCostsBudgetAndMonth: {},
        lodingeditAdministrativeCostsBudgetAndMonth: false,
        erroreditAdministrativeCostsBudgetAndMonth: null,


        DeleteAdministrativeCostsAndMonth: {},
        lodingDeleteAdministrativeCostsAndMonth: false,
        errorDeleteAdministrativeCostsAndMonth: null,


        ValidationAdministrativeCosts: [],
        lodingValidationAdministrativeCosts: false,
        errorValidationAdministrativeCosts: null,

        monthEdit: [],
        ItemTypeAdministrativeCostsBudgetFilter: {}
    }, reducers: {
        setmonthEdit: (state, action) => {
            //console.log(action.payload, "sssssssssssdwdwd");

            state.monthEdit = action.payload
        },

        setClearValidationAdministrativeCosts:(state,action)=>{
            state.ValidationAdministrativeCosts=[]
        },
        filterItemTypeAdministrativeCostsBudget: (state, action) => {
            if (state.ItemTypeAdministrativeCostsBudget != undefined) {
                let result = state.ItemTypeAdministrativeCostsBudget.filter((ele, ind) => {
                    return ele.bI_AB_ItemTypeAdministrativeCostsBudgetId == action.payload
                })

                state.ItemTypeAdministrativeCostsBudgetFilter = result[0]
            }
        }
    }, extraReducers: (builder) => {
        builder
            .addCase(AdministrativeCosts.pending, (state, action) => {
                state.lodingAddAdministrativeCosts = true;
                state.AddAdministrativeCosts = action.payload;
                state.errorAddAdministrativeCosts = null;
            })
            .addCase(AdministrativeCosts.fulfilled, (state, action) => {
                state.lodingAddAdministrativeCosts = false;
                state.AddAdministrativeCosts = action.payload; // Assuming payload has the desired data
            })
            .addCase(AdministrativeCosts.rejected, (state, action) => {
                state.lodingAddAdministrativeCosts = false;
                state.errorAddAdministrativeCosts = action.payload;
            })
        ////////////////////////////////////////////////////

        builder
            .addCase(GetBI_AB_ItemTypeAdministrativeCostsBudget.pending, (state, action) => {
                state.lodingItemTypeAdministrativeCostsBudget = true;
                state.ItemTypeAdministrativeCostsBudget = action.payload;
                state.errorItemTypeAdministrativeCostsBudget = null;
            })
            .addCase(GetBI_AB_ItemTypeAdministrativeCostsBudget.fulfilled, (state, action) => {
                state.lodingItemTypeAdministrativeCostsBudget = false;
                state.ItemTypeAdministrativeCostsBudget = action.payload; // Assuming payload has the desired data
            })
            .addCase(GetBI_AB_ItemTypeAdministrativeCostsBudget.rejected, (state, action) => {
                state.lodingItemTypeAdministrativeCostsBudget = false;
                state.errorItemTypeAdministrativeCostsBudget = action.payload;
            })
        //////////////////////////////GetAdministrativeCostsAndMonthById//////////////////////////////////////
        builder
            .addCase(GetAdministrativeCostsAndMonthById.pending, (state, action) => {
                state.lodingAdministrativeCostsBudgetAndMonth = true;
                state.AdministrativeCostsBudgetAndMonth = action.payload;
                state.errorAdministrativeCostsBudgetAndMonth = null;
            })
            .addCase(GetAdministrativeCostsAndMonthById.fulfilled, (state, action) => {
                state.lodingAdministrativeCostsBudgetAndMonth = false;
                state.AdministrativeCostsBudgetAndMonth = action.payload; // Assuming payload has the desired data
            })
            .addCase(GetAdministrativeCostsAndMonthById.rejected, (state, action) => {
                state.lodingAdministrativeCostsBudgetAndMonth = false;
                state.errorAdministrativeCostsBudgetAndMonth = action.payload;
            })
        //////////////////////////////GetAdministrativeCostsAndMonthById//////////////////////////////////////
        builder
            .addCase(EditAdministrativeCostsAndMonth.pending, (state, action) => {
                state.lodingeditAdministrativeCostsBudgetAndMonth = true;
                state.editAdministrativeCostsBudgetAndMonth = action.payload;
                state.erroreditAdministrativeCostsBudgetAndMonth = null;
            })
            .addCase(EditAdministrativeCostsAndMonth.fulfilled, (state, action) => {
                state.lodingeditAdministrativeCostsBudgetAndMonth = false;
                state.editAdministrativeCostsBudgetAndMonth = action.payload; // Assuming payload has the desired data
            })
            .addCase(EditAdministrativeCostsAndMonth.rejected, (state, action) => {
                state.lodingeditAdministrativeCostsBudgetAndMonth = false;
                state.erroreditAdministrativeCostsBudgetAndMonth = action.payload;
            })
        ////////////////////////////////////////////////////////////////////////////
        builder
            .addCase(DeleteAdministrativeCostsAndMonth.pending, (state, action) => {
                state.lodingDeleteAdministrativeCostsAndMonth = true;
                state.DeleteAdministrativeCostsAndMonth = action.payload;
                state.errorDeleteAdministrativeCostsAndMonth = null;
            })
            .addCase(DeleteAdministrativeCostsAndMonth.fulfilled, (state, action) => {
                state.lodingDeleteAdministrativeCostsAndMonth = false;
                state.DeleteAdministrativeCostsAndMonth = action.payload; // Assuming payload has the desired data
            })
            .addCase(DeleteAdministrativeCostsAndMonth.rejected, (state, action) => {
                state.lodingDeleteAdministrativeCostsAndMonth = false;
                state.errorDeleteAdministrativeCostsAndMonth = action.payload;
            })
        ////////////////////////////////////////////////////////////////////////////
        builder
            .addCase(ValidationAdministrativeCosts.pending, (state, action) => {
                state.lodingValidationAdministrativeCosts = true;
                state.ValidationAdministrativeCosts = action.payload;
                state.errorValidationAdministrativeCosts = null;
            })
            .addCase(ValidationAdministrativeCosts.fulfilled, (state, action) => {
                state.lodingValidationAdministrativeCosts = false;
                state.ValidationAdministrativeCosts = action.payload; // Assuming payload has the desired data
            })
            .addCase(ValidationAdministrativeCosts.rejected, (state, action) => {
                state.lodingValidationAdministrativeCosts = false;
                state.errorValidationAdministrativeCosts = action.payload;
            })
    }
})


export const { setmonthEdit, filterItemTypeAdministrativeCostsBudget,setClearValidationAdministrativeCosts } = AdministrativeCostsReducer.actions
export default AdministrativeCostsReducer.reducer
